import { invariant } from "@banjoanton/utils";
import type { OpeningMatch } from "./classify-opening-util";
import type { Opening } from "../models/chess-game-model";
export type OpeningParts = {
    family: string;
    variations?: string[];
};

const parseOpeningName = (name: string): OpeningParts => {
    const [familyRaw, ...rest] = name.split(":");
    const family = familyRaw?.trim();

    invariant(family, "family doesn't exist");

    if (rest.length === 0) {
        return { family };
    }

    const restRaw = rest.join(":");

    const variations = restRaw
        .split(",")
        .map((p) => p.trim())
        .filter(Boolean);

    return { family, variations };
};

const getFormattedOpening = (match: OpeningMatch, version: string): Opening => {
    const { family, variations } = parseOpeningName(match.name);

    const opening: Opening = {
        version,
        eco: match.eco,
        name: { family, ...(variations && { variations }) },
        ply: match.ply,
    };
    return opening;
};

const getUnknownOpening = (): Opening => ({
    version: "unknown",
    eco: "UNK",
    name: { family: "Unknown" },
    ply: 0,
});

export const OpeningUtil = {
    parseOpeningName,
    getFormattedOpening,
    getUnknownOpening,
};
